import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22omnyqra.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22./Manrope-Regular.woff2%22,%22weight%22:%22400%22,%22style%22:%22normal%22},{%22path%22:%22./Manrope-SemiBold.woff2%22,%22weight%22:%22600%22,%22style%22:%22normal%22},{%22path%22:%22./Manrope-Bold.woff2%22,%22weight%22:%22700%22,%22style%22:%22normal%22},{%22path%22:%22./Manrope-ExtraBold.woff2%22,%22weight%22:%22800%22,%22style%22:%22normal%22}],%22display%22:%22swap%22,%22preload%22:false,%22variable%22:%22--font-display%22,%22fallback%22:[%22Arial%22,%22sans-serif%22]}],%22variableName%22:%22manrope%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'manrope', 'manrope Fallback', Arial, sans-serif",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
